/**
 * "2 kun oldin" rather than a timestamp.
 *
 * A register is read by scanning: an exact time is only useful once you have
 * already found the row, and a column of them is noise. The exact value stays
 * available as the cell's title attribute.
 */
const UNITS = [
  ["yil", 365 * 24 * 60 * 60],
  ["oy", 30 * 24 * 60 * 60],
  ["kun", 24 * 60 * 60],
  ["soat", 60 * 60],
  ["daqiqa", 60],
];

export function relativeTime(iso) {
  if (!iso) return "—";
  const seconds = Math.floor((Date.now() - new Date(iso).getTime()) / 1000);
  if (Number.isNaN(seconds)) return "—";
  if (seconds < 60) return "hozirgina";

  for (const [label, size] of UNITS) {
    const n = Math.floor(seconds / size);
    if (n >= 1) return `${n} ${label} oldin`;
  }
  return "hozirgina";
}

/**
 * Dates are formatted here, by hand, rather than handed to toLocaleDateString.
 *
 * The `uz-UZ` locale is not carried consistently: the same call gives
 * "18-sentabr, 2026" under Node's ICU and "2026 M09 18" in Chromium, which is
 * what shipped and is not a date anybody in Uzbekistan reads. Spelling the
 * months out makes the output identical in every browser and on the server.
 */
const MONTHS = [
  "yanvar", "fevral", "mart", "aprel", "may", "iyun",
  "iyul", "avgust", "sentabr", "oktabr", "noyabr", "dekabr",
];

const two = (n) => String(n).padStart(2, "0");

/** "18-sentabr 2026" */
export function formatDate(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  return `${d.getDate()}-${MONTHS[d.getMonth()]} ${d.getFullYear()}`;
}

/** "16:04" — 24-hour, which is what an audit log wants. */
export function clockTime(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  return `${two(d.getHours())}:${two(d.getMinutes())}`;
}

/** The full value, for a title attribute: "18-sentabr 2026, 16:04". */
export const exactTime = (iso) =>
  iso ? `${formatDate(iso)}, ${clockTime(iso)}` : "";
